// e.g. /dashboard/year/2024/evaluations, /states/year/2024/projects or /evaluations/2024/projects/educators
const YEAR_PATH = /^(\/[a-z-]+(?:\/year)?\/\d{4})(\/.*)?$/;

/**
 * The school year root of a pathname, e.g. `/dashboard/year/2024` for
 * `/dashboard/year/2024/evaluations`. Works even when the year is not in the
 * network's list of school year links (e.g. it predates the network).
 */
export function getSchoolYearRoot(pathname) {
  return pathname.match(YEAR_PATH)?.[1];
}

/**
 * The part of a pathname after the school year, e.g. `/evaluations` for
 * `/dashboard/year/2024/evaluations`. Returns an empty string if there is none.
 *
 * Uses the current school year link when there is one, and otherwise falls back
 * to parsing the pathname, since the year may not be in the list of links.
 */
export function getPathAfterSchoolYear(pathname, currentLink) {
  if (currentLink) {
    return pathname.split(currentLink.href)[1] || '';
  }

  return pathname.match(YEAR_PATH)?.[2] || '';
}
